var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('virtual-list',{staticClass:"layout-gl-list scroll-touch",attrs:{"data-key":'id',"data-sources":_vm.groupList,"data-component":_vm.itemComponent,"estimate-size":50,"item-class":'layout-gl-list-item'}})}
var staticRenderFns = []

export { render, staticRenderFns }